import { createFileRoute } from '@tanstack/react-router'
import { TasksPage } from '@/features/tasks/tasks-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/tasks')({
  component: TasksRoute,
})

function TasksRoute() {
  const { workspaceSlug } = Route.useParams()

  return <TasksPage workspaceSlug={workspaceSlug} />
}
